import { gql } from '@apollo/client'

export const QUERY_FEEDBACKS_LIST = gql`
    query FeedbacksList($companyId: ID, $page: Int!, $limit: Int!) {
        feedbacks(companyId: $companyId, page: $page, limit: $limit) {
            feedbacks {
                _id
                text
                assignedCompany
                submissionDate
                score
                answers {
                    category
                    score
                }
                user {
                    userFullname
                }
            }
            documentCount
        }
    }
`

export const Mutation_UPSERT_FEEDBACK = gql`
    mutation MutationUpsertUserFeedback($encryptedUserData: UserDataInput!) {
        upsertUserFeedback(encryptedUserData: $encryptedUserData) {
            _id
            questionPoolId
            score
        }
    }
`

export const MUTATION_UPDATE_FEEDBACK = gql`
    mutation MutationUpdateFeedback($feedback: UpdateFeedbackInput!) {
        updateFeedback(feedback: $feedback)
    }
`
export const MUTATION_MARK_FEEDBACK_REVIEWED = gql`
    mutation markFeedbacksAsReviewed($feedbackIds: [ID!]!) {
        markFeedbacksAsReviewed(feedbackIds: $feedbackIds)
    }
`

export const USER_FEEDBACK_QUERY = gql`
    query feedback($encryptedUserData: UserDataInput!) {
        feedback(encryptedUserData: $encryptedUserData) {
            _id
            questionPoolId
            score
        }
    }
`
